module.exports = __webpack_public_path__ + "img/event_mobile_5.8924d6c7.png";